import React from "react";
import { Box, Card, CardContent } from "@mui/material";
import CardDateRangePickerRow from "visual-components/util/cards/card-date-range-picker-row";
import CardTabs from "visual-components/util/cards/card-tabs";

const defaultTabs = [
  {
    ref: "dashboardEmailsAcquired",
    title: "emails acquired",
  },
  {
    ref: "dashboardSocialActions",
    title: "social actions",
  },
  {
    ref: "dashboardCampaignsLaunched",
    title: "campaigns launched",
  },
  {
    ref: "dashboardNewPartnerships",
    title: "new partnerships",
  },
];

/**
 * Overview Card Component
 * Main dashboard card with tabs and date range picker
 * @param {Object} props
 * @param {import("react").ReactNode} props.children - Card content
 * @param {Object} props.aggregates - Aggregate data for tabs
 * @param {Function} [props.changeFilter] - Date filter change handler
 * @param {Date} [props.oldestDate] - Oldest selectable date
 * @param {Object} [props.datePickerAggregateTop] - Date picker props
 * @param {Array} [props.tabs] - Tab configuration
 * @returns {import("react").ReactElement}
 */
export default function OverviewCard(props) {
  const {
    children,
    aggregates,
    changeFilter,
    oldestDate,
    datePickerAggregateTop,
    tabs = defaultTabs,
  } = props;

  return (
    <Card sx={{ width: "100%", height: "100%" }}>
      <CardContent sx={{ p: 0 }}>
        <CardTabs {...props} tabs={tabs} data={aggregates} />
        <Box sx={{ p: 3 }}>{children}</Box>
        {changeFilter && (
          <CardDateRangePickerRow
            oldestDate={oldestDate}
            changeFilter={changeFilter}
            {...datePickerAggregateTop}
          />
        )}
      </CardContent>
    </Card>
  );
}
